import { render, staticRenderFns } from "./hashTag.vue?vue&type=template&id=d735ddf4&class=full-height"
import script from "./hashTag.vue?vue&type=script&lang=js"
export * from "./hashTag.vue?vue&type=script&lang=js"
import style0 from "./hashTag.vue?vue&type=style&index=0&id=d735ddf4&scope=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\GitHub\\ita.GroupTravel.Website\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d735ddf4')) {
      api.createRecord('d735ddf4', component.options)
    } else {
      api.reload('d735ddf4', component.options)
    }
    module.hot.accept("./hashTag.vue?vue&type=template&id=d735ddf4&class=full-height", function () {
      api.rerender('d735ddf4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/ita/toursCombine/tcSetting/hashTag.vue"
export default component.exports